export enum SandboxErrorCode {
    Error,
    PortfolioSet,
    PortfolioSetNotFound,
    PortfolioSetNull,
    PortfolioSetName,
    PortfolioSetSave,
}
